import React from 'react';
import { GlobalStyles, useTheme, Button } from '@mui/material';

export const nextLabel = `
  <button
    style="
      background-color: #27C9D4;
      box-shadow: 0px 3px 10px 0px #187B814D;
      color: white;
      border: none;
      border-radius: 10px;
      padding: 10px 20px;
      font-size: 15px;
      height:46px;
      line-height:18px;
      font-weight:700;
      width: 100%,
      cursor: pointer;
      width: 100%;
      box-sizing: border-box;
    "
  >
    הבא
  </button>
`;

export const prevLabel = `
  <button
    style="
      background-color: transparent;
      color: #27C9D4;
      border: 1px solid #27C9D4;
      border-radius: 10px;
      padding: 10px 20px;
      font-size: 15px;
      height:46px;
      line-height:18px;
      font-weight:700;
      width: 100%,
      cursor: pointer;
      width: 100%;
      box-sizing: border-box;
    "
  >
    חזור
  </button>
`;
const doneLabel = `
  <button
    style="
      background-color: #27C9D4;
      box-shadow: 0px 3px 10px 0px #187B814D;
      color: white;
      border: none;
      border-radius: 10px;
      padding: 10px 20px;
      font-size: 15px;
      height:46px;
      line-height:18px;
      font-weight:700;
      width: 100%,
      cursor: pointer;
      width: 100%;
      box-sizing: border-box;
    "
  >
    סיום
  </button>
  `;

export const HomePage = {
  steps: [
      {
        title:"עמוד הבית",
        intro: `
        <div>
            <p class="myIntoText">
              ברוכים הבאים לאפליקציית הלקוחות שלנו, באמצעות האפליקציה ניתן יהיה לבצע הזמנות, לפתוח קריאות שירות, לצפות בארכיון ועוד.
            </p>
        </div>
        `,
    },
    {
      title:"בר תחתון",
      element: '#home1',
      tooltipClass: "home1intro",
      highlightClass: "home1-helper-rounded", 
      intro: `
      <div>
          <p class="myIntoText">
             באמצעות הבר התחתון תוכלו לנווט בעמודים השונים באפליקציה.
          </p>
      </div>
      `,
    },
    {
      title:"בחירת סניף",
      element: '#home2',
      intro: `
      <div>
          <p class="myIntoText">
            כאן ניתן לבחור סניף מתוך רשימת הסניפים של בית העסק.
          </p>
      </div>
      `,
    },

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: doneLabel,  
};

export const NotificationPage = {
  steps: [
      {
        title:"התראות",
        element:"#notification1",
        intro: `
        <div>
            <p class="myIntoText">
              כאן תוכלו לראות את כל החידושים והעדכונים במהלך השימוש באפליקציה. לסימון ״קראתי״ לחצו על ההתראה.
            </p>
        </div>
        `,
    },

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: doneLabel,  
};

export const CatalogPage = {
  steps: [
      {
        title:"קטלוג מוצרים",
        intro: `
        <div>
            <p class="myIntoText">
              בקטלוג המוצרים יופיעו כל המוצרים אשר פתוחים להזמנה בהתאם להסכם שנחתם.
            </p>
        </div>
        `,
    },
    {
      title:"הוספת פריט",
      element:"#catalog2",
      tooltipClass: "catalog2intro introjsArrow",
      intro: `
      <div>
          <p class="myIntoText">
            בלחיצה על כפתור ה +, יתווספו המוצרים לעגלת הקניות.
          </p>
      </div>
      `,
    },
    {
      title:"הוספת פריט",
      element:"#catalog3",
      tooltipClass: "catalog3intro",
      intro: `
      <div>
          <p class="myIntoText">
            בעת יצירת ההזמנה, סך היחידות שהוזמנו מכל מוצר יסוכמו כאן.
          </p>
      </div>
      `,
    },

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: doneLabel,  
};

export const ServicePage = {
  steps: [
      {
        title:"המכונות שלי",
        element:"#service1",
        intro: `
        <div>
            <p class="myIntoText">
              כאן יופיעו כל המכונות המשויכות לבית העסק לפי סניף.
            </p>
        </div>
        `,
    },
    {
      title:"המכונות שלי",
      element:"#service2",
      highlightClass: "service2-rounded", 
      intro: `
      <div>
          <p class="myIntoText">
           בלחיצה על כרטיסיית המכונה, ניתן יהיה לראות מידע שונה לגבי המכונה ולפתוח קריאות שירות.
          </p>
      </div>
      `,
    },

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: doneLabel,  
};

export const BussniseTour = {
  steps: [
      {
        title:"יצירת/עריכת הרשאות חדשות ",
        element:"#bussnies1",
        intro: `
        <div>
            <p class="myIntoText">
             כאן ניתן להקים הרשאות עבור עובדים בבית העסק. להקמת עובד חדש יש ללחוץ על ה +.
            </p>
        </div>
        `,
    },


  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: nextLabel,  
};

export const BussniseTour2 = {
  steps: [
    {
      title:"יצירת/עריכת הרשאות חדשות",
      element:"#bussnies2",
      highlightClass: "service2-rounded", 
      intro: `
      <div>
          <p class="myIntoText">
           לאחר הזנת פרטי העובד, יש לבחור תפקיד והרשאות. הסבר בגין כל הרשאה יופיע בעת לחיצה על התגית. במידה ולא קיימת הרשאה מתאימה, ניתן ללחוץ על "יצירת/עריכת הרשאות".
          </p>
      </div>
      `,
    }

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: nextLabel,  
};

export const BussniseTour3 = {
  steps: [
    {
      title:"הוספת תפקיד חדש",
      element:"#bussnies3",
      highlightClass: "service2-rounded", 
      intro: `
      <div>
          <p class="myIntoText">
           יש לבחור שם וצבע לתגית ואת ההרשאות הרצויות. לבחירת הרשאה יש לסמן V.
          </p>
      </div>
      `,
    }

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: nextLabel,  
};

export const BussniseTour4 = {
  steps: [
    {
      title:"עריכת עובד",
      element:"#bussnies4",
      highlightClass: "service2-rounded", 
      intro: `
      <div>
          <p class="myIntoText">
            כאן ניתן לשנות ולעדכן את פרטי העובד, הרשאותיו והסניפים אליו משוייך. כמו כן, ניתן למחוק את העובד כליל.
          </p>
      </div>
      `,
    },

  ],
  nextLabel: nextLabel,
  prevLabel: prevLabel,
  doneLabel: doneLabel,  
};